<!-- <div mat-dialog-title class="dialog-header">
  <div class="dialog-title">
    <mat-icon class="title-icon">{{ data.icon }}</mat-icon>
    <h2 class="title-text">{{ data.title }}</h2>
  </div>
  <button mat-icon-button class="close-button" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</div> -->

<mat-dialog-content class="dialog-content">
  <p class="dialog-message">{{ data.message }}</p>
</mat-dialog-content>
